<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { SheetContent, SheetTitle } from "~/shadcn/components/ui/sheet";
import { Separator } from "~/shadcn/components/ui/separator";
import { useStoreUserV2 } from "~/stores/storeUserV2";
import { ArrowLeft, X, HeartHandshake, DollarSign, Euro, Languages } from "lucide-vue-next";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import { DrawerContent, DrawerTitle } from "~/shadcn/components/ui/drawer";
import ProfileDrawerFooterButton from "~/components/profile/ProfileDrawerFooterButton.vue";
import { useStoreApp } from "~/stores/storeApp";

const { t } = useI18n();

const userStore = useStoreUserV2();
const app = useStoreApp();

const breakpoints = useBreakpoints(breakpointsTailwind);

const breakpointIsLgOrAbove = breakpoints.greaterOrEqual("lg");

const restartOnboarding = () => {
  console.log("restart onboarding");
  app.showOnboardingModal = true;
  userStore.closeProfileDrawer();
};
</script>

<template>
  <component
    :is="breakpointIsLgOrAbove ? SheetContent : DrawerContent"
    class="border-none outline-none p-0 bg-slate-950 text-white h-screen flex flex-col justify-between"
    hide-default-close-button
  >
    <component
      :is="breakpointIsLgOrAbove ? SheetTitle : DrawerTitle"
      class="p-6 pb-3 flex items-center justify-between"
    >
      <div class="w-full flex flex-row items-center gap-4">
        <ArrowLeft
          class="cursor-pointer"
          aria-label="Back"
          @click="userStore.openProfileDrawer('default')"
        />

        <span class="grow">{{ t("drawers.profile.settings") }}</span>

        <X
          class="w-4 cursor-pointer hidden lg:block"
          aria-label="Close"
          @click.stop="userStore.closeProfileDrawer()"
        />
      </div>
    </component>

    <div class="grow flex flex-col items-stretch h-full">
      <Separator class="bg-slate-600" />

      <div class="p-6 flex flex-col justify-start items-stretch gap-6">
        <ProfileDrawerButton nav @click="restartOnboarding">
          <template #icon>
            <HeartHandshake class="w-4" />
          </template>
          {{ t("drawers.profile.settingsView.onboarding.restart") }}
        </ProfileDrawerButton>

        <ProfileDrawerCurrencySwitcher />
        <ProfileDrawerLanguageSwitcher />
        <ProfileDrawerWalletInfo />
      </div>
    </div>

    <ProfileDrawerFooterButton @click="userStore.openProfileDrawer('default')">
      <template #icon>
        <ArrowLeft class="" />
      </template>
      {{ t("drawers.back", "Back") }}
    </ProfileDrawerFooterButton>
  </component>
</template>
